module.exports = __webpack_public_path__ + "img/partner11.edbf78ee.png";